import { ArrowClockwiseIcon, WarningCircleIcon } from '@phosphor-icons/react'
import { GhostButton } from '../buttons/ghost-button'
import * as styles from './error-boundary-fallback.css'

type ErrorBoundaryFallbackProps = {
  title: string
  detail: React.ReactNode
  onRetry: () => unknown
  isRetrying?: boolean
}

export const ErrorBoundaryFallback: React.FC<ErrorBoundaryFallbackProps> = ({
  title,
  detail,
  onRetry,
  isRetrying = false,
}) => (
  <div className={styles.container} role="alert">
    <p className={styles.title}>
      <WarningCircleIcon size={20} weight="fill" aria-hidden />
      {title}
    </p>
    <p className={styles.detail}>{detail}</p>
    <GhostButton size="small" ariaDisabled={isRetrying} icon={<ArrowClockwiseIcon size={14} />} onClick={onRetry}>
      Retry
    </GhostButton>
  </div>
)
